import { Card, Col, Row, Tabs, Typography } from 'antd';

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Layout from '../../layouts/User';
import { useSelector } from 'react-redux';
import MyOrdersTap from '../../components/MyOrders/Tab_OrderBig';
import MyOrdersTap2 from '../../components/MyOrders/Tab_OrderSmall';

const MyOrders: React.FC = () => {
  const { Text } = Typography;
  const { TabPane } = Tabs;
  const user = useSelector((state: any) => state.user);
  const [activeKeyshow, setactiveKeyshow] = useState<string>('1');
  const [ValStatus, setValStatus] = useState<number>(0);
  const [orders, setOrders] = useState<any>([]);
  const [ordersShop, setOrdersShop] = useState<any>([]);
  const [allOrders, setAllOrders] = useState<any>([]);
  const [allOrdersShop, setAllOrdersShop] = useState<any>([]);
  const [status, setStatus] = useState<string>('waiting_payment');

  const [ValStatusTab1, setValStatusTab1] = useState<number>(0);
  const [ValStatusTab2, setValStatusTab2] = useState<number>(0);
  const [ValStatusTab3, setValStatusTab3] = useState<number>(0);
  const [ValStatusTab4, setValStatusTab4] = useState<number>(0);
  const [ValStatusTab5, setValStatusTab5] = useState<number>(0);
  const [ValStatusTab6, setValStatusTab6] = useState<number>(0);

  const breadcrumbs = [
    {
      text: 'หน้าหลัก',
      path: '/',
    },
    {
      text: 'คำสั่งซื้อของฉัน',
    },
  ];

  const getOrder = async () => {
    if (user._id) {
      const allOrder = await axios.get(
        `/orders/all-orders-user/${user._id}`
      );

      setAllOrders(allOrder.data);
    }
    if (user._id) {
      const allOrdersShop = await axios.get(
        `/ordershops/all-orders-shop-user/${user._id}`
      );

      setAllOrdersShop(allOrdersShop.data);
    }
  };

  const getApis = (tabKey?: string) => {
    if (allOrders.length) {
      let ordersFilter = allOrders.filter(
        (x: any) => x.status === tabKey
      );
      if (tabKey === 'waiting_payment') {
        const ordersFilter2 = allOrders.filter(
          (x: any) => x.status === 'waiting_new_payment'
        );
        const mergeOrdersFilter = ordersFilter.concat(ordersFilter2);
        ordersFilter = mergeOrdersFilter;
      }

      setValStatus(ordersFilter.length);
      setOrders(ordersFilter);
    }
  };

  const getApisTabSmall = (tabKey?: string) => {
    // console.log("test tabkey value =>", tabKey);

    if (allOrdersShop.length) {
      let ordersFilterSmall = allOrdersShop.filter(
        (x: any) => x.status === tabKey
      );

      if (tabKey === 'shop_prepare_delivery') {
        const ordersShopFilter2 = allOrdersShop.filter(
          (x: any) => x.status === 'on_delivery'
        );
        const mergeOrdersShopFilter =
          ordersFilterSmall.concat(ordersShopFilter2);
        ordersFilterSmall = mergeOrdersShopFilter;
      }

      if (tabKey === 'success') {
        const ordersShopFilter2 = allOrdersShop.filter(
          (x: any) => x.status === 'success_transfer'
        );
        const mergeOrdersShopFilter =
          ordersFilterSmall.concat(ordersShopFilter2);
        ordersFilterSmall = mergeOrdersShopFilter;
      }

      if (tabKey === 'cancelled') {
        const ordersShopFilter2 = allOrdersShop.filter(
          (x: any) => x.status === 'check_payment_cancel'
        );

        let mergeOrdersShopFilter =
          ordersFilterSmall.concat(ordersShopFilter2);
        const ordersShopFilter3 = allOrdersShop.filter(
          (x: any) => x.status === 'shop_prepare_delivery_cancel'
        );

        let mergeOrdersShopFilter2 =
          mergeOrdersShopFilter.concat(ordersShopFilter3);

        const ordersShopFilter4 = allOrdersShop.filter(
          (x: any) => x.status === 'cancelled_transfer'
        );
        let mergeOrdersShopFilter3 =
          mergeOrdersShopFilter2.concat(ordersShopFilter4);

        ordersFilterSmall = mergeOrdersShopFilter3;
      }

      setValStatus(ordersFilterSmall.length);
      setOrdersShop(ordersFilterSmall);
    }
  };
  const setValueOrderStatus = () => {};

  useEffect(() => {
    // setValStatus(0);
    //getApis("waiting_payment");
    getOrder();
    setStatus(status);
  }, []);
  useEffect(() => {}, [ordersShop]);
  useEffect(() => {
    const xval = [
      'waiting_payment',
      'waiting_new_payment',
      'check_payment',
    ];
    if (allOrders.length) {
      getApis(status);
      getApisTabSmall(status);
      setValueOrderStatus();
      for (let i = 0; i < xval.length; i++) {
        const ordersFilter = allOrders.filter(
          (x: any) => x.status === xval[i]
        );
        let waitingPaymentCount = 0;
        if (ordersFilter.length) {
          if (ordersFilter[0].status === 'waiting_payment') {
            waitingPaymentCount = ordersFilter.length;
            setValStatusTab1(ordersFilter.length);
          } else if (
            ordersFilter[0].status === 'waiting_new_payment'
          ) {
            setValStatusTab1(
              ordersFilter.length + waitingPaymentCount
            );
          } else if (ordersFilter[0].status === 'check_payment') {
            setValStatusTab2(ordersFilter.length);
          }
        }
      }
    }
  }, [allOrders]);

  useEffect(() => {
    const xval = [
      'shop_prepare_delivery',
      'on_delivery',
      'shop_delivered',
      'success',
      'success_transfer',
      'check_payment_cancel',
      'shop_prepare_delivery_cancel',
      'cancelled_transfer',
      'cancelled',
      // 'check_payment',
    ];
    if (allOrdersShop.length) {
      let shopPrepareDeliveryCount = 0;
      let successCount = 0;
      let checkPaymentCancelCount = 0;
      let shopPrepareDeliveryCancelCount = 0;
      let shopcancelledTransferCount = 0;
      for (let i = 0; i < xval.length; i++) {
        const ordersFilter = allOrdersShop.filter(
          (x: any) => x.status === xval[i]
        );

        if (ordersFilter.length) {
          if (ordersFilter[0].status === 'shop_prepare_delivery') {
            shopPrepareDeliveryCount = ordersFilter.length;
            setValStatusTab3(ordersFilter.length);
          } else if (ordersFilter[0].status === 'on_delivery') {
            setValStatusTab3(
              ordersFilter.length + shopPrepareDeliveryCount
            );
          } else if (ordersFilter[0].status === 'shop_delivered') {
            setValStatusTab4(ordersFilter.length);
          } else if (ordersFilter[0].status === 'success') {
            successCount = ordersFilter.length;
            setValStatusTab5(ordersFilter.length);
          } else if (ordersFilter[0].status === 'success_transfer') {
            setValStatusTab5(ordersFilter.length + successCount);
          } else if (
            ordersFilter[0].status === 'check_payment_cancel'
          ) {
            checkPaymentCancelCount = ordersFilter.length;
            setValStatusTab6(ordersFilter.length);
          } else if (
            ordersFilter[0].status === 'shop_prepare_delivery_cancel'
          ) {
            shopPrepareDeliveryCancelCount = ordersFilter.length;
            setValStatusTab6(
              ordersFilter.length + checkPaymentCancelCount
            );
          } else if (
            ordersFilter[0].status === 'cancelled_transfer'
          ) {
            shopcancelledTransferCount = ordersFilter.length;
            setValStatusTab6(
              ordersFilter.length +
                checkPaymentCancelCount +
                shopPrepareDeliveryCancelCount
            );
          } else if (ordersFilter[0].status === 'cancelled') {
            setValStatusTab6(
              ordersFilter.length +
                checkPaymentCancelCount +
                shopPrepareDeliveryCancelCount +
                shopcancelledTransferCount
            );
          }

        }
      }
    }
  }, [allOrdersShop]);

  const onChangeTabs = (e: string) => {
    setStatus(e);
  };

  const onTabChangeState = (tabKey?: string) => {
    // set tab...
    if (tabKey) {
      onChangeTabs(tabKey);
    }
  };

  useEffect(() => {
    getApis(status);
    getApisTabSmall(status);
  }, [status]);

  useEffect(() => {
    if (user) {
      getOrder();
    }
  }, [user]);

  return (
    <>
      <Layout breadcrumbItems={breadcrumbs}>
        <Row justify="center">
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card className="Card-Container">
              <Tabs
                className="Tabs"
                activeKey={status}
                onChange={onChangeTabs}
              >
                <TabPane
                  tab={`รอการชำระเงิน ${`(${ValStatusTab1})`}`}
                  key="waiting_payment"
                >
                  <MyOrdersTap
                    orders={orders}
                    type="waiting_payment"
                    onTabChangeState={onTabChangeState}
                  />
                </TabPane>
                {/* {=====TAB1 END======} */}
                <TabPane
                  tab={`ตรวจสอบการชำระเงิน ${`(${ValStatusTab2})`}`}
                  key="check_payment"
                >
                  <MyOrdersTap
                    orders={orders}
                    type="check_payment"
                    onTabChangeState={onTabChangeState}
                  />
                </TabPane>
                {/* {=====TAB2 END======} */}

                {/* {Orderย่อย} */}
                <TabPane
                  tab={`เตรียมจัดส่ง ${`(${ValStatusTab3})`}`}
                  key="shop_prepare_delivery"
                >
                  <MyOrdersTap2
                    orders={ordersShop}
                    type="shop_prepare_delivery"
                    onTabChangeState={onTabChangeState}
                  />
                </TabPane>
                {/* {=====TAB3 END======} */}
                <TabPane
                  tab={`จัดส่งแล้ว  ${`(${ValStatusTab4})`}`}
                  key="shop_delivered"
                >
                  <MyOrdersTap2
                    orders={ordersShop}
                    type="shop_delivered"
                    onTabChangeState={onTabChangeState}
                  />
                </TabPane>

                {/* {=====TAB4END======} */}
                <TabPane
                  tab={`สำเร็จ ${`(${ValStatusTab5})`}`}
                  key="success"
                >
                  <MyOrdersTap2
                    orders={ordersShop}
                    type="success"
                    onTabChangeState={onTabChangeState}
                  />
                </TabPane>

                {/* {=====TAB5 END======} */}
                <TabPane
                  tab={`ยกเลิก ${`(${ValStatusTab6})`}`}
                  key="cancelled"
                >
                  <MyOrdersTap2
                    orders={ordersShop}
                    type="cancelled"
                    onTabChangeState={onTabChangeState}
                  />
                </TabPane>
                {/* {=====TAB6 END======} */}
              </Tabs>
            </Card>
          </Col>
        </Row>
      </Layout>
    </>
  );
};

export default MyOrders;
